


















































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import DropdownCheckbox from '@/components/DropdownCheckbox.vue';
import TrTable from '@/components/TrTable.vue';
import Box from '@/components/Box.vue';
import { AbstractDataClass, IColumn } from '../helpers/AbstractDataClass';

@Component({
  components: {
    Box,
    DropdownCheckbox,
    TrTable,
  },
})
export default class Table<T> extends Vue {
  searchWord: string = '';
  // Data
  @Prop(Array) private data: Array<AbstractDataClass<T>>;
  @Prop(Array) private arraySelect: Array<string>;
  @Prop(Array) private arrayTable: Array<any>;

  // Name properties
  @Prop(String) private placeholder: String;
  @Prop(String) private nameDropdown: String;

  // Other props
  @Prop(Boolean) private canOtherPut: Boolean;
  @Prop(String) private to?: String;
  @Prop(String) private search?: String;

  @Emit('onDelete')
  onDelete(value: Object) {
    return value;
  }

  @Emit('onAdd')
  onAdd(value: { code: string }) {
    return value;
  }

  @Emit('activeCreate')
  activeCreate() {}

  @Emit('putEvent')
  putEvent() {}

  @Emit('onCancel')
  onCancel() {}

  @Emit('onCreate')
  public onCreate(data: AbstractDataClass<T>) {
    return data;
  }

  @Emit('addBox')
  addBox(arg: Object) {
    return arg;
  }

  @Emit('deleteBox')
  deleteBox(arg: Object) {
    return arg;
  }

  @Emit('onPut')
  onPut(arg: any) {
    return arg;
  }

  private get columns(): Array<IColumn> {
    if (Array.isArray(this.data) && this.data.length > 0)
      return this.data[0].columns;
    return [];
  }

  //function computer for filter Table
  private get arrayTableFilter(): any {
    if (this.data && this.searchWord!) {
      return this.data.filter((d: AbstractDataClass<T>) => {
        let found = false;
        let i = 0;
        while (!found && i < d.columns.length) {
          found =
            d._id === undefined ||
            (d.columns[i].isSearchable &&
              d[d.columns[i].rel!] &&
              d[d.columns[i].rel!]
                .toLowerCase()
                .includes(this.searchWord!.toLowerCase()));
          i++;
        }
        return found;
      });
    } else {
      return this.data;
    }
  }

  public mounted() {
    this.searchWordWithRouterQuery();
  }

  public searchWordWithRouterQuery() {
    if (this.$route.query != undefined && this.$route.query.search)
      this.searchWord = this.$route.query.search.toString();
  }
}
